import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import {useBoolean} from 'src/hooks/use-boolean';
import {useResponsive} from 'src/hooks/use-responsive';
// components
import {useSettingsContext} from 'src/components/settings';
//
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';
import ConnectModal from './connect-modal';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {userApi} from 'src/store/user/userApi';
import ProfileDrawer from 'src/components/profile-drawer/profile-drawer';
import CustomDrawer from 'src/components/custom-drawer/CustomDrawer';
import {useEffect} from 'react';

// ----------------------------------------------------------------------

export default function DashboardLayout({children}) {
  const settings = useSettingsContext();
  const smDown = useResponsive('down', 'sm');
  const {getMy} = useSelector(store => store.user)

  const [alfaSwitch, setAlfaSwitch] = useState(false)

  useEffect(() => {
    if (getMy) {
      const enableAlfaIdAuth = getMy?.enable_alfa_id_auth
      setAlfaSwitch(enableAlfaIdAuth)
    }
  }, [getMy])

  const lgUp = useResponsive('up', 'lg');
  const [triggerGainAccess, fetchGainAccessQuery] = userApi.useLazyUserOrderGainAccessQuery()

  const [showConnectModal, setShowConnectModal] = useState()

  const onOpenShowConnectModal = () => setShowConnectModal(true)
  const onCloseShowConnectModal = () => setShowConnectModal(false)
  const [showProfile, setShowProfile] = useState()

  const onOpenShowProfile = () => setShowProfile(true)
  const onCloseShowProfile = () => setShowProfile(false)

  const app = useSelector(store => store.app)
  const selectedEndpointId = useSelector(store => store.endpoint.selectedEndpoint?.id)
  const userPermission = useSelector(store => store.user?.permissions)
  const permissions = userPermission?.endpoints ? userPermission.endpoints[selectedEndpointId] : {}

  const isDemo = permissions?.merchant_is_demo


  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const onApply = async () => {
    const res = await triggerGainAccess({
      merchant_id: permissions?.merchant_id,
      user_order_type: 'gain_access_to_prod'
    })

    if (res?.status === 'fulfilled') {
      onCloseShowConnectModal()
    }
  }

  const connectModal = showConnectModal ? (
    <ConnectModal
      open={showConnectModal}
      onClose={onCloseShowConnectModal}
      onApply={onApply}
    />
  ) : null

  const renderNavMini = <NavMini onOpenShowConnectModal={onOpenShowConnectModal} isDemo={isDemo} />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = (
    <NavVertical
      openNav={nav.value}
      onCloseNav={nav.onFalse}
      onOpenShowConnectModal={onOpenShowConnectModal}
      isDemo={isDemo}
    />
  );

  const profileView = (
    <ProfileDrawer
      onClose={onCloseShowProfile}
      alfaSwitch={alfaSwitch}
      setAlfaSwitch={setAlfaSwitch}
      getMy={getMy}
    />
  )

  const profileDrawer = (
    <CustomDrawer
      onClose={onCloseShowProfile}
      open={showProfile}
      {...(smDown && {
        PaperProps: {
          style: {
            maxWidth: '100%',
            width: '100%',
          }
        }
      })}
    >
      {profileView}
    </CustomDrawer>
  )

  if (isHorizontal) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} onOpenShowProfile={onOpenShowProfile} />

        {lgUp ? renderHorizontal : renderNavVertical}
        {connectModal}
        <Main>{children}</Main>
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} onOpenShowProfile={onOpenShowProfile} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}
          {connectModal}
          <Main>{children}</Main>
        </Box>
      </>
    );
  }


  return (
    <>
      {profileDrawer}
      <Header onOpenNav={nav.onTrue} onOpenShowProfile={onOpenShowProfile} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: {xs: 'column', md: 'row'},
        }}
      >
        {renderNavVertical}
        {connectModal}
        <Main>{(smDown && showProfile) ? profileView : children}</Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
